module.exports = __webpack_public_path__ + "static/media/project-setup.9e49689c.png";